export class DateUtil {

	public static getCurrentDateString(): string {
		return new Date().toISOString().split('T')[0];
	}
}
